'use client';

import { SpecialPageSellerPanelType } from './type';
import { Icon } from '@theme/components';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { SpecialPageStore } from './store-banner';
import { SpecialPageTabs } from './tabs';
import { Banner } from './banner';
import { useLocalization } from '@akinon/next/hooks';
import { SpecialPageSellerInfo } from './seller-info';
import { SpecialPageProfile } from './profile';
import { cn } from '@theme/utils';

export default function SpecialPageSellerPanel({
  brand,
  productCount,
  data
}: SpecialPageSellerPanelType) {
  const { t } = useLocalization();

  const tabs = [
    {
      key: 'store',
      label: t('category.store')
    },
    ...(data?.attributes?.seller_info?.length > 0
      ? [
          {
            key: 'profile',
            label: t('category.seller_profile')
          }
        ]
      : [])
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].key);

  if (!data?.attributes.desktop_image || !data?.attributes?.mobile_image)
    return null;

  const { desktop_image, mobile_image } = data.attributes;

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    const list = document.getElementById('list-wrapper');
    if (tab === 'profile') {
      if (list) {
        list.setAttribute('style', 'display: none');
      }
    } else {
      list.setAttribute('style', 'display: block');
    }
  };
  return (
    <>
      <div className="max-w-[1536px] mx-auto">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:min-w-[60%]">
            <Banner image={desktop_image} isDesktop />
            <Banner image={mobile_image} isDesktop={false} />
          </div>

          <div
            className="px-6 lg:px-[52px] pt-5 pb-8 lg:py-5 h-auto lg:w-[40%] flex flex-col justify-center"
            style={{
              backgroundColor:
                data?.attributes?.image_props?.value?.text_bg_color || '#f7f7f7'
            }}
          >
            <h2 className="text-lg font-bold mb-6">
              {data?.attributes?.image_props?.value?.title}
            </h2>
            {data?.attributes?.image_props?.value?.description && (
              <div
                className="text-sm font-medium lg:max-w-[420px]"
                dangerouslySetInnerHTML={{
                  __html: data?.attributes?.image_props?.value?.description
                }}
              />
            )}
            {data?.attributes?.image_props?.value?.button_text && (
              <div
                className="flex items-center mt-[18px] md:mt-[26px] cursor-pointer"
                onClick={() =>
                  typeof window !== 'undefined' &&
                  window.scrollTo({
                    top: window.innerWidth < 768 ? 600 : 700,
                    left: 0,
                    behavior: 'smooth'
                  })
                }
              >
                <div className="underline text-sm">
                  {data?.attributes?.image_props?.value?.button_text}
                </div>
                <Icon
                  name="chevron-double-down"
                  size={14}
                  className="text-black p-1"
                />
              </div>
            )}
          </div>
        </div>
        <div
          className={cn(
            'lg:container relative',
            data?.attributes?.profile && '-top-4 lg:-top-12'
          )}
        >
          <SpecialPageProfile
            data={data}
            brand={brand}
            productCount={productCount}
          />
          <div className="mt-5 md:mt-7 flex items-start gap-4 border-b border-gray-900">
            {tabs?.map((tab, key) => (
              <div
                key={key}
                onClick={() => handleTabChange(tab.key)}
                className={twMerge(
                  'text-sm md:text-base px-6 lg:px-3 leading-6 cursor-pointer pb-1.5 relative',
                  activeTab === tab.key ? 'text-black' : 'text-gray-900'
                )}
              >
                {tab.label}
                {activeTab === tab.key && (
                  <div className="absolute w-full h-1 left-0 bg-secondary bottom-0" />
                )}
              </div>
            ))}
          </div>
          {activeTab === 'store' && <SpecialPageStore data={data} />}
          {activeTab === 'profile' && <SpecialPageSellerInfo data={data} />}
        </div>
      </div>
      {data?.attributes?.tabs?.length > 0 && activeTab !== 'profile' && (
        <SpecialPageTabs data={data} />
      )}
    </>
  );
}
